import React, { Component}  from 'react';
import { connect } from 'react-redux';
import {List, Map} from "immutable";

import MainRoutes from '../routes/MainRoutes';
import { AppToaster } from '../components/common/toaster';
import {detectBody, smoothlyMenu} from "../components/common/LayoutHelpers";

import { markNotificationAsShown, deleteNotification } from '../actions/notifications';
import { signout } from '../actions/auth';

import CustMenu from "../components/common/CustMenu";

class AppLayout extends Component {

    constructor(props) {
        super(props);

        this.state = {
            miniNavbar: false
        };
    }

    componentDidMount() {
        ['load', 'resize'].map(e => window.addEventListener(e, () => detectBody()));
    }

    componentDidUpdate(prevProps, prevState) {
        const { notifications } = this.props;

        if (notifications && notifications.size > 0) {
            notifications.forEach(notification => {
                const notificationId = notification.get('notificationId');
                if (!notification.get('shown')) {

                    // onDismiss is a function called when the notification closes. We use this to delete the notification from Redux store.
                    notification = notification.set('onDismiss', () => this.props.deleteNotification(notificationId));

                    // Show the notification in app toaster if not already shown
                    AppToaster.show(notification.toJS());

                    // Immediately mark the notification as shown
                    this.props.markNotificationAsShown(notificationId);
                }
            });
        }

        const { miniNavbar } = this.state;

        if (miniNavbar !== prevState.miniNavbar) {
            document.body.classList.toggle('mini-navbar', miniNavbar);
            smoothlyMenu();
        }
    }

    onChangeMiniNavbar = (e) => {
        e.preventDefault();
        this.setState({
            miniNavbar: !this.state.miniNavbar
        });
    };

    render() {
        const { miniNavbar } = this.state;
        const { location } = this.props;

        return (
            <div id="wrapper">
                <CustMenu
                    location={location}
                    miniNavbar={miniNavbar}
                    onChangeMiniNavbar={this.onChangeMiniNavbar}
                    signout={ this.props.signout }
                    user={this.props.user}
                />
                <MainRoutes {...this.props} />
            </div>
        );
    }
}

function mapStateToProps(state) {

    // Reducers
    const notificationsReducer = state.notifications;
    const sessionReducer = state.auth.session;

    // Notifications
    const notifications = notificationsReducer || List([]);

    // Session
    const user = sessionReducer.get('user') || Map({});

    return {
        notifications,
        user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        markNotificationAsShown: (notificationId) => dispatch(markNotificationAsShown(notificationId)),
        deleteNotification: (notificationId) => dispatch(deleteNotification(notificationId)),
        signout: () => dispatch(signout())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);


// WEBPACK FOOTER //
// ./src/containers/AppLayout.js